import { useState, FC } from 'react'
import { useTranslation } from 'react-i18next'
import PerButton from '../../../components/custom_components/Button'
import { useEmployeeWithAppraisalInviteInfo } from '../../../graphql/employee/hooks/useEmployeeWithAppraisalInviteModalInfo'
import { NewLoadingAndErrors } from '../../../components/custom_components/LoadingAndErrors/NewLoadingAndErrors'
import { MeetingType, SkillEmployeeStatusDto } from '../../../types'
import { AppraisalInviteModalPublicProfile } from '../../companySettings/appraisal/AppraisalInviteModalPublicProfile'

interface NewMeetingInviteButtonProps {
  employeeId: string
  employeeSkillStatus: SkillEmployeeStatusDto | null
}

export const AppraisalInviteButton: FC<NewMeetingInviteButtonProps> = ({ employeeId, employeeSkillStatus }) => {
  const [t] = useTranslation()
  const [isModalOpen, setIsModalOpen] = useState(false)

  const { data, error, loading } = useEmployeeWithAppraisalInviteInfo(employeeId)

  if (
    !data ||
    !data.appraisalSeasonOptionByEmployeeId ||
    !data.employeeDisplayTinyInfoByEmployeeId ||
    !data.nonParticipantsOptionsForEmployee ||
    !data.meetingInviteOptionsForEmployee ||
    error ||
    loading
  ) {
    return loading ? <NewLoadingAndErrors t={t} hasNoData={false} isLoading={loading} showSpinner /> : <></>
  }

  const cleanAndCloseModal = () => {
    setIsModalOpen(false)
  }

  const employee = data.employeeDisplayTinyInfoByEmployeeId
  const appraisalSeason = data.appraisalSeasonOptionByEmployeeId
  const additionalParticipantOptions = data.nonParticipantsOptionsForEmployee
  const meetingInviteOptionsForEmployee = data.meetingInviteOptionsForEmployee
  const possibleAppraisalType: MeetingType = meetingInviteOptionsForEmployee.possible.find((type) =>
    [MeetingType.Appraisal, MeetingType.AppraisalUpdate].includes(type),
  )!
  const isAppraisalOptionsAvailable =
    meetingInviteOptionsForEmployee.isAppraisalEnabled && !meetingInviteOptionsForEmployee.tagAssignmentIsInProgress
  const disabledButton = !isAppraisalOptionsAvailable

  return (
    <>
      {isModalOpen && (
        <AppraisalInviteModalPublicProfile
          employee={employee}
          onCancel={cleanAndCloseModal}
          visible={isModalOpen}
          appraisalSeason={appraisalSeason}
          meetingType={possibleAppraisalType}
          additionalParticipantOptions={additionalParticipantOptions}
          skillStatusData={employeeSkillStatus}
        />
      )}

      <PerButton
        onClick={(e) => {
          e.preventDefault()
          setIsModalOpen(true)
        }}
        before="invite_fill"
        color="primary"
        text={t('meetingButtonActions.invite')}
        disabled={disabledButton}
        tooltip={
          disabledButton &&
          t(`profile.meetings.invite.appraisalNotAvailableTooltip`, {
            appraisalType: t(`meetingTypes.${possibleAppraisalType}`),
            employeeName: employee.firstName + ' ' + employee.lastName,
          })
        }
      />
    </>
  )
}
